/**
 * Contrato estável de kind Memed (espelha o backend).
 */

export const MEMED_DOCUMENT_KINDS = [
  'prescription',
  'recipe',
  'certificate',
  'exam',
] as const;

export type MemedDocumentKind = (typeof MEMED_DOCUMENT_KINDS)[number];

export function isCertificateExamKind(kind: MemedDocumentKind): boolean {
  return kind === 'certificate' || kind === 'exam';
}

export function memedKindFromClinicalUi(
  type: 'PRESCRIPTION' | 'RECIPE' | 'CERTIFICATE' | 'EXAM',
): MemedDocumentKind {
  if (type === 'CERTIFICATE') return 'certificate';
  if (type === 'EXAM') return 'exam';
  if (type === 'RECIPE') return 'recipe';
  return 'prescription';
}

export function memedKindLabel(kind: MemedDocumentKind): string {
  if (kind === 'certificate') return 'atestado';
  if (kind === 'exam') return 'pedido de exame';
  if (kind === 'recipe') return 'receituário';
  return 'receita';
}

export function memedKindOperation(kind: MemedDocumentKind, phase: 'open' | 'issue'): string {
  if (kind === 'certificate') {
    return phase === 'open' ? 'certificate_open' : 'certificate_issue';
  }
  if (kind === 'exam') {
    return phase === 'open' ? 'exam_open' : 'exam_issue';
  }
  return phase === 'open' ? 'prescription_open' : 'prescription_issue';
}
